import React, { FC } from 'react';
import cs from 'classnames';
import { useTranslation } from '@wix/wix-i18n-config';
import { Dismiss } from '@wix/wix-ui-icons-common';

import { Accordion } from '../Accordion/Accordion';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { useFedopsLogger } from '../../contexts/FedopsLoggerContext';
import { useMenuCategoryGroups } from '../../hooks/useMenuCategoryGroups';
import { usePageScroll } from '../../contexts/PageScrollContext';
import { useTemplatesPageUI } from '../../contexts/TemplatesPageUIContext';

import { bottomNavigationMenuDataHooks as dataHooks } from './BottomNavigationMenu.dataHooks';

import Icon from '../../icons/MenuToggle.svg';
import s from './BottomNavigationMenu.scss';

export const BottomNavigationMenu: FC = () => {
  const { isCategoriesMenuOpen, toggleCategoriesMenu } = useTemplatesPageUI();
  const { t } = useTranslation();
  const { reportBrowseSidebar } = useBiLogger();
  const fedopsLogger = useFedopsLogger();
  const categoryGroups = useMenuCategoryGroups();
  const { scrollToTop } = usePageScroll();

  const accordionData = categoryGroups.map(({ title, categories }) => ({
    title,
    content: categories.map((menuCategory) => ({
      url: menuCategory.url,
      active: menuCategory.isActive,
      label: menuCategory.label,
      id: menuCategory.slug,
    })),
  }));

  const browseBy = (
    <span className={s.toggle}>
      <Icon />
      <span>{t('app.topBar.menu.toggle.label')}</span>
    </span>
  );

  return (
    <>
      <div className={cs(s.mobile)} onClick={() => toggleCategoriesMenu(true)}>
        {browseBy}
      </div>
      <div
        data-hook={dataHooks.container()}
        className={cs(s.navigationMenu, {
          [s.open]: isCategoriesMenuOpen,
        })}
      >
        {isCategoriesMenuOpen && (
          <div
            onClick={() => toggleCategoriesMenu(false)}
            className={s.backdrop}
          />
        )}
        <div className={s.content}>
          {isCategoriesMenuOpen && (
            <button
              className={s.dismiss}
              onClick={() => toggleCategoriesMenu(false)}
            >
              <Dismiss color="black" />
            </button>
          )}

          <Accordion
            data={accordionData}
            onItemClick={(bucketName: string) =>
              reportBrowseSidebar(bucketName)
            }
            onSubitemClick={(categoryName: string) => {
              reportBrowseSidebar(categoryName);
              fedopsLogger.startCategorySwitchInteraction();
              scrollToTop();
              toggleCategoriesMenu(false);
            }}
          />
        </div>
      </div>
    </>
  );
};
